<template>
    <div class="wrap-review">
        <div class="review-item" v-for="(item, index) in list" :key="index">
            <!-- <div class="avatar-info flex">
                <div class="left">
                    <img :src="item.image || avatar_default" alt class="avatar" />
                    <span>{{ item.nickname }}</span>
                </div>
                <div class="right">
                    <el-rate v-model="item.star" disabled :colors="['#4CA5E4', '#4CA5E4', '#4CA5E4']" text-color="#4CA5E4"></el-rate>
                </div>
            </div>
            <div class="content">{{ item.content }}</div>
            <div class="img-list cover">
                <div class="img-item" v-for="(url, index) in item.images" :key="index" alt>
                    <el-image style="" :src="url" :preview-src-list="item.images"> </el-image>
                </div>
            </div>
            <div class="date">{{ item.createdTime }}</div> -->
            <div class="cLeft">
                <el-image class="elImg" :src="item.image || avatar_default" fit="cover"></el-image>
                <div class="titleBox">
                    <div class="text">{{ item.nickname }}</div>
                    <div class="text">{{ item.createdTime }}</div>
                </div>
            </div>
            <div class="cRight">
                <el-rate v-model="item.star" :colors="colors" disabled show-score class="elRate" score-template="" text-color="#4CA5E4"></el-rate>
                <div class="elRateBg"></div>
                <div class="text">{{ item.content }}</div>
                <div class="imgFlexBox">
                    <el-image
                        v-for="(url, index) in item.images"
                        :key="index"
                        class="imgElImg"
                        :src="url"
                        :preview-src-list="item.images"
                        fit="cover"
                    >
                    </el-image>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'review-list',
    components: {},
    props: ['list'],
    data() {
        return {
            colors: ['#ff4d00', '#ff4d00', '#ff4d00', '#ff4d00', '#ff4d00'],
        }
    },
    watch: {},
    computed: {
        ...mapState(['']),
    },
    methods: {},
}
</script>

<style scoped lang="less">
/deep/ .el-rate__icon {
    // color: #ff4d00 !important;
    font-size: 22px !important;
}

/deep/ .el-rate__item {
    width: 22px;
    height: 22px;
}

.wrap-review {
    .review-item {
        padding: 40px;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #d5d8de;
        margin-bottom: 20px;
        display: flex;
        align-items: start;
        justify-content: space-between;

        .cLeft {
            width: 200px;
            display: flex;
            align-items: center;
            justify-content: center;

            .elImg {
                width: 64px;
                height: 64px;
                margin-right: 24px;
            }

            .titleBox {
                width: calc(100% - 64px - 24px);
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                .text {
                    width: 100%;
                    font-weight: 400;
                    font-size: 12px;
                    color: #666666;
                    line-height: 12px;
                    margin-bottom: 12px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        .cRight {
            width: calc(100% - 200px - 108px);
            position: relative;

            .elRateBg {
                width: 120px;
                height: 30px;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 9;
            }

            .elRate {
                position: relative;
                left: -4px;
            }

            .text {
                width: 100%;
                margin-top: 10px;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 26px;
            }

            .imgFlexBox {
                margin-top: 40px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;

                .imgElImg {
                    width: 140.5px;
                    height: 100px;
                    margin-right: 16px;
                }
            }
        }

        .avatar-info {
            .left {
                min-width: 150px;

                .avatar {
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    object-fit: cover;
                }

                span {
                    flex: 2;
                    margin-left: 10px;
                    display: inline-block;
                    // min-width: 100px;
                    text-align: left;

                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                }
            }

            .right {
            }
        }

        .content {
            margin: 20px 0;
            padding-left: 150px;
            text-align: left;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 30px;
            color: #222222;
        }

        .img-list {
            .flex();
            padding-left: 150px;
            text-align: left;

            .img-item {
                width: 100px;
                height: 100px;
                margin-right: 15px;
                border: 1px solid #eee;

                .el-image {
                    width: 100%;
                    height: 100%;
                }
            }

            img {
                // width: 100px;
                // height: 100px;
                // margin-right: 10px;
                // margin-bottom: 10px;
            }
        }

        .date {
            margin-top: 20px;
            padding-left: 150px;
            text-align: left;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 19px;
            color: #999999;
        }
    }
}

// 手机端
@media screen and (max-width: 1199px) {
    .wrap-review {
        .review-item {
            padding: 10px 0;
            border-bottom: 1px solid #eee;

            .avatar-info {
                .flex();
                justify-content: space-between;

                .left {
                    min-width: 150px;
                    .flex-center();

                    .avatar {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        object-fit: cover;
                    }

                    span {
                        flex: 2;
                        margin-left: 10px;
                        display: inline-block;
                        // min-width: 100px;
                        text-align: left;

                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #333333;
                    }
                }

                .right {
                }
            }

            .content {
                margin: 10px 0;
                padding-left: 0;
                text-align: justify;
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 1.7;
                color: #222222;
            }

            .img-list {
                .flex();
                padding-left: 0;
                text-align: left;

                .img-item {
                    width: 100px;
                    height: 100px;
                    margin-right: 15px;
                    border: 1px solid #eee;
                    width: 70px;
                    height: 70px;

                    .el-image {
                        width: 100%;
                        height: 100%;

                        width: 70px;
                        height: 70px;
                    }
                }

                img {
                    // width: 100px;
                    // height: 100px;
                    // margin-right: 10px;
                    // margin-bottom: 10px;
                }
            }

            .date {
                margin-top: 20px;
                padding-left: 0;
                text-align: left;
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 1.2;
                color: #999999;
            }
        }
    }
}
</style>

<style scoped lang="less" src="@/assets/h5css/mobile/product-detail.less"></style>
